import * as angular from "angular";

export class PricePlanRequestsService {
  constructor(private $pricePlan, private PricePlanAPI) {
  }


  getTemplatesByType(type) {
    const api = this.PricePlanAPI.actions.getTemplatesByType;
    return this.$$call(api, {type: type}, {}, {});
  }

  createTemplate(type, name) {
    const api = this.PricePlanAPI.actions.createTemplate;
    return this.$$call(api, {}, {pricePlanType: type, pricePlanName: name}, {});
  }

  updateProgramTemplate(programId, templateId) {
    const api = this.PricePlanAPI.actions.updateProgramTemplate;
    return this.$$call(api, {}, {}, {programId: programId, parentId: templateId});
  }

  getProgramData(pricePlanId, accountId?, fromData?, toData?, allLocations?) {
    const api = this.PricePlanAPI.actions.getProgramData;
    return this.$$call(api,
      {accountId: accountId},
      {fromRequests: fromData, toRequests: toData, allLocations: allLocations},
      {
        pricePlanId: pricePlanId
      });
  }

  getPricePlanPreferences(_programId, _group, _accountId?) {
    const api = this.PricePlanAPI.actions.getPricePlanPreferences;
    return this.$$call(api, {
      accountId: _accountId,
    }, {groupList: _group}, {
      pricePlanId: _programId
    });
  }

  savePricePlanPreferences(_pricePlanId, _accountId, _preferences, _group) {
    const api = this.PricePlanAPI.actions.savePricePlanPreferences;
    return this.$$call(api, {
      accountId: _accountId,
      group: _group
    }, _preferences, {
      pricePlanId: _pricePlanId
    });
  }

  editProgramConfiguration(pricePlanId, payload, accountId?) {
    const api = this.PricePlanAPI.actions.savePricePlanPreferences;
    return this.$$call(api, {accountId: accountId}, payload, {pricePlanId: pricePlanId});
    // return $pricePlan(pricePlanId).$post(payload, {fromArea: pickupId, toArea: dropOffId, accountId: accountId})
  }

  deleteRelationPricePlanPreferences(pricePlanId, fromId?, toId?) {
    const api = this.PricePlanAPI.actions.deleteRelationPricePlanPreferences;
    return this.$$call(api, {fromId: fromId, toId: toId}, {}, {pricePlanId: pricePlanId});
    // return $pricePlan(pricePlanId).$post(payload, {fromArea: pickupId, toArea: dropOffId, accountId: accountId})
  }

  // ******************************
  // Internal methods
  // ******************************

  $$call(_apiCall, _params, _data, _options) {
    return this.$pricePlan().$call(_apiCall, _params, _data, _options);
  }
}

angular
  .module('bringoz.admin.pricePlan')
  .service('pricePlanRequestsService', PricePlanRequestsService);
